module.exports = __webpack_public_path__ + "img/rowing_white.39fc8e12.svg";